export type ColumnVisibility = {
  showName: boolean;
  showJobsite: boolean;
  showPhotographer: boolean;
  showType: boolean;
  showCaptureDate: boolean;
  showUploadDate: boolean;
  showImages: boolean;
  showStatus: boolean;
};

export const COLUMN_WEIGHT = {
  name: 4,
  jobsite: 3,
  photographer: 3,
  type: 2,
  captureDate: 3,
  uploadDate: 3,
  images: 2,
  status: 4,
} as const;

export const TOTAL_COLUMNS = 24;

export const THUMBNAIL_WIDTH_PX = 220;
export const ACTIONS_WIDTH_PX = 48;

type SizeKey = keyof typeof COLUMN_WEIGHT;

const VISIBILITY_KEY: Record<SizeKey, keyof ColumnVisibility> = {
  name: "showName",
  jobsite: "showJobsite",
  photographer: "showPhotographer",
  type: "showType",
  captureDate: "showCaptureDate",
  uploadDate: "showUploadDate",
  images: "showImages",
  status: "showStatus",
};

const CANONICAL_ORDER = Object.keys(COLUMN_WEIGHT) as SizeKey[];

export type ColumnSizes = Record<SizeKey, number> & { total: number };

export const getColumnSizes = (
  visibleColumns: ColumnVisibility,
): ColumnSizes => {
  const visibleKeys = CANONICAL_ORDER.filter(
    (key) => visibleColumns[VISIBILITY_KEY[key]],
  );

  const sizes = {} as Record<SizeKey, number>;
  for (const key of CANONICAL_ORDER) sizes[key] = 0;

  if (visibleKeys.length === 0) {
    return { ...sizes, total: TOTAL_COLUMNS };
  }

  const totalVisibleWeight = visibleKeys.reduce(
    (sum, key) => sum + COLUMN_WEIGHT[key],
    0,
  );
  const lastVisibleKey = visibleKeys[visibleKeys.length - 1];

  let allocated = 0;
  for (const key of visibleKeys) {
    if (key === lastVisibleKey) continue;
    const size = Math.round(
      (COLUMN_WEIGHT[key] / totalVisibleWeight) * TOTAL_COLUMNS,
    );
    sizes[key] = size;
    allocated += size;
  }
  sizes[lastVisibleKey] = TOTAL_COLUMNS - allocated;

  return { ...sizes, total: TOTAL_COLUMNS };
};
